module.exports=function(scope){ return `// Custom text for continue button
"zoom_action_continue" = "Custom Continue Message";
`};


// WEBPACK FOOTER //
// ./src/resources/code/ios/20-custom-string.swift.tpl